export default __webpack_public_path__ + "pgnv-assets/ab1adcab852c68789da5da6dc3acd160.png";